import styles from './Loader.module.scss';

interface LoaderProps {
    size?: number;
    tintColor?: string;
    backgroundColor?: string;
}

export function Loader(props: LoaderProps): React.ReactElement {
    const { size = 100, ...restProps } = props;

    return <div className={styles.loader}>
        <div
        className={styles.loaderSpinner}
        style={{
            width: size,
            height: size,
            borderColor: restProps.tintColor,
            borderTopColor: restProps.backgroundColor
        }}
        />
    </div>
}


